import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

class SearchDetector extends React.Component {
  componentDidMount() {
    const { didMountDetectingJudger } = this.props;

    if (didMountDetectingJudger !== undefined && didMountDetectingJudger(this.props)) {
      this.detect(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { willReceivePropsDetectingJudger } = this.props;

    if (willReceivePropsDetectingJudger(this.props, nextProps)) {
      this.detect(nextProps);
    }
  }

  detect = props => {
    const { onDetect, ...rest } = _.omit(props, [
      'dispatch',
      'didMountDetectingJudger',
      'willReceivePropsDetectingJudger'
    ]);
    onDetect(rest);
  };

  render() {
    return null;
  }
}

export default connect()(SearchDetector);
